import { memo } from "react";
import { useRouteError } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";

export const RouterErrorBounder = memo(() => {
  const error: any = useRouteError();

  return (
    <Box
      height="100dvh"
      width="100dvw"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Box mb={3} maxWidth={600}>
        <Typography variant="h1" color="primary" align="center">
          {error?.name}
        </Typography>
      </Box>
      <Box mb={3} maxWidth={600}>
        <Typography variant="h4" color="secondary" align="center">
          {error.message}
        </Typography>
      </Box>

      {error.cause && (
        <Box>
          <Typography variant="subtitle1" align="center">
            Server response
          </Typography>

          <Typography align="center">{error.cause}</Typography>
        </Box>
      )}
    </Box>
  );
});
